var Cookie = {
    cookieLaw: {

        path: '/',
        exist: function(name) {
            var newCookieAcc = document.cookie.match(new RegExp(name + '=acconsento'));
            var newCookieNotAcc = document.cookie.match(new RegExp(name + '=non acconsento'));
            return (newCookieAcc !== null && newCookieAcc !== 'undefined') || (newCookieNotAcc !== null && newCookieNotAcc !== 'undefined');
        },
        create: function(name, value) {
            var date = new Date();
            date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
            document.cookie = name + '=' + value + '; expires=' + date.toGMTString() + '; path=' + Cookie.cookieLaw.path;
        },
        accept: function() {
            var cookieCreato = false;
            if (!Cookie.cookieLaw.exist('cookieAnalytics')) {
            Cookie.cookieLaw.create('cookieAnalytics', 'acconsento');
            cookieCreato = true;
            }
        },

        scrollEvents: function() {
            $(document).on("scrollstart",function(event){
            if (window.codeScroll) {
                window.manualScroll = false;
                window.codeScroll = false;

            } else {
                window.manualScroll = true;
            }


            });

            $(document).on("scrollend",function(event){
            if(typeof window.startScroll === 'undefined') {
                window.startScroll = 0;
            }

            var endScroll= $(window).scrollTop();

            var distance = Math.abs(window.startScroll - endScroll);
            if (window.manualScroll && (distance>=100)) {

                if (typeof window.canAcceptCookie !== 'undefined' && window.canAcceptCookie) {
                $(document).off('scrollend scrollstart');
                Cookie.cookieLaw.accept();

                }

            }

            window.startScroll = endScroll;


            });

        },
        init: function() {

            $(document).ready(function() {
                if (!Cookie.cookieLaw.exist('cookieAnalytics')) {
                    $('.banner-cookie-wrapper').removeClass('hide');
                    $('.banner-cookie-wrapper').fadeIn(300, function() {
                        window.canAcceptCookie = true;
                        Cookie.cookieLaw.scrollEvents();
                    });
                } else {
                    Cookie.cookieLaw.accept();
                }
                $('body').on('click', function(e) {
                    // if (!Cookie.cookieLaw.exist('commercial')) {
                    //     if ($(e.target).is('.nega-consenso')) {

                    //     }
                    // }
                    if (!Cookie.cookieLaw.exist('cookieAnalytics')) {
                        if (!$(e.target).is('.banner-cookie-wrapper .info')) {
                            Cookie.cookieLaw.accept();
                            location.reload();
                        }
                        if ($(e.target).is('.nega-consenso')) {
                            if (!Cookie.cookieLaw.exist('cookieAnalytics')) {
                                Cookie.cookieLaw.create('cookieAnalytics', 'non acconsento');
                            }
                        }
                    }
                });
                // $('.banner-cookie-wrapper .btn').click(function(event) {
                    // event.preventDefault();
                    // //console.log("ACCETTA COOKIES!!!2");
                    // Cookie.cookieLaw.accept();
                    // location.reload();
                // });
            });
        }
    },
};

$(document).ready(function () {
    Cookie.cookieLaw.init();
});